import React from 'react';
import useStyles from './Styles';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ChartTitle from './ChartTitle';
import appActions from '../app/actions';

const ChartView = () => {
    const classes = useStyles();
    const { chart } = useSelector((state) => state.arizona);
    const { setChartDrawerStateToClose } = appActions();
    return (
        <Box className={classes.chartView} onClick={()=>{ setChartDrawerStateToClose() }}>
            {
                chart === 'shortage_impacts_to_river_communities_vs_central_arizona' ?
                <ChartTitle floating={true} title={"Shortage Impacts to River Communities vs Central Arizona"} subtitle={"Big River Policy Name"} background="#EDEDED" /> :
                chart === 'shortage_impacts_by_arizona_region' ?
                <ChartTitle title={"Shortage Impacts by Arizona Region"} subtitle={"Big River Policy Name"} /> : ''
            }
            <Box>Content starts from here</Box>
        </Box>
    );
};

export default ChartView;